import { render, staticRenderFns } from "./EditNewRegistrationDialog.vue?vue&type=template&id=b0876930&"
import script from "./EditNewRegistrationDialog.vue?vue&type=script&lang=js&"
export * from "./EditNewRegistrationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports